import { STATIC_HM_PATH } from "@project/shared-types";
import { useEffect, useState } from "react";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";
import { _colorText, _sizeHeading, _sizeText } from "../../core/core";
import "./How.css";

export const How = ({ block, ...props }: { block: any }) => {
  const [step, setStep] = useState(0);
  const totalSteps = block.steps.length;

  // Function to get the correct style based on the current step
  const get_style = (index: number) => {
    return index === step ? _colorText.default : _colorText.black;
  };

  // useEffect to set up interval for automatic step change
  useEffect(() => {
    const interval = setInterval(() => {
      setStep((prevStep) => (prevStep + 1) % totalSteps);
    }, 5000); // Change step every 5 seconds

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [totalSteps]);

  return (
    <div className="how">
      <Title type={_sizeHeading.h2}>{block.title}</Title>
      <div className="how-body">
        <div className="how-body-l">
          <img
            src={`${STATIC_HM_PATH}/images/how_s_${step}.webp`}
            alt={`Step ${step}`}
            className="how-image"
          />
        </div>
        <div className="how-body-r">
          {block.steps.map((step_data: any, index: number) => (
            <div
              key={index}
              onClick={() => setStep(index)}
              className={`how-card ${index === step ? "h-true" : ""}`}
            >
              <div className="h-card-title">
                <Title type={_sizeHeading.h3} color={get_style(index)}>
                  {step_data.title}
                </Title>
              </div>
              <Text size={_sizeText.m} color={get_style(index)}>
                {step_data.text}
              </Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
